// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3SlS9","replay-button":"Button_replay-button__1CCp_"};